import { createContext, memo, useContext, useEffect, useState } from "react";
import { Loader } from "@components/loader";
import { getProfile } from "@network/identity/user/getProfile";
import type * as types from "./types";

const UserContext = createContext<any>(null);

export const UserProvider = memo((props: types.IProps) => {
  const [state, setState] = useState<types.IUserState>({
    ready: false,
    data: null,
  });

  useEffect(() => {
    getProfile()
      .then((data) => {
        setState({
          ready: true,
          data,
        });
      })
      .catch(() => {
        setTimeout(() => {
          window.location.replace(window._env_.WEB_DASHBOARD);
        }, 1000);
      });
  }, []);

  if (state.ready)
    return (
      <UserContext.Provider value={state}>
        {props.children}
      </UserContext.Provider>
    );
  else return <Loader />;
});

export const useUserConsumers = (): types.IUserConsumers =>
  useContext(UserContext);
